import React, { useRef, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const MaterialKitchenModal = ({ show, onClose }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [stockData, setStockData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(1);

    // Fetch kitchen stock with pagination and search
    const fetchKitchenStock = async () => {
        setLoading(true);
        try {
            const res = await fetch(
                `${baseURL}/kitchen-stock?per_page=${perPage}&page=${page}&search=${searchTerm}`
            );
            const data = await res.json();
            if (data.status === 'success') {
                setStockData(data.data || []);
                setTotalPages(data.pagination?.last_page || 1);
            } else {
                setStockData([]);
                setTotalPages(1);
            }
        } catch (err) {
            console.error(err);
            setStockData([]);
            setTotalPages(1);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (show) fetchKitchenStock();
    }, [show, page, perPage, searchTerm]);

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Kitchen Room Details</h3>
                    <Button variant="" type="button" className="close px-6 py-1" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>

                <div className="modal-body">
                    {/* Controls */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1);
                                }}
                                style={{ fontSize: '0.85rem', height: '30px' }}
                            >
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={125}>125</option>
                            </select>
                        </div>

                        <div>
                            <input
                                type="text"
                                placeholder="Search by Raw Material..."
                                className="form-control"
                                style={{ fontSize: '0.85rem', height: '40px' }}
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1);
                                }}
                            />
                        </div>
                    </div>

                    {/* Table */}
                    <div className="table-container">
                        <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className='min-w-100px text-start'>Raw Material</th>
                                    <th className='min-w-100px text-center'>Stock Quantity</th>
                                </tr>
                            </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7">
                {stockData.length > 0 ? (
                    stockData.map((item, idx) => (
                        <tr key={idx}>
                            <td className='text-black'>{item.raw_material_name || '-'}</td>
                            <td className='text-black text-center'>
                                {item.stock_quantity} {item.stock_unit || '-'}
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="2" className="text-center">No records found.</td>
                    </tr>
                )}
                                </tbody>

                        </table>

                        {/* Pagination */}
                        <div className="d-flex justify-content-between align-items-center mt-2">
                            <span className="text-muted">
                                Page {page} of {totalPages}
                            </span>
                           <nav>
                            <ul className="pagination mb-0" style={{ fontSize: "0.6rem" }}>
                                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link py-0 px-1"
                                        style={{ minWidth: "25px" }}
                                        onClick={() => setPage(page - 1)}
                                    >
                                        Prev
                                    </button>
                                </li>

                                {[...Array(totalPages)].map((_, i) => (
                                    <li key={i} className={`page-item ${page === i + 1 ? "active" : ""}`}>
                                        <button
                                            className="page-link py-0 px-1"
                                            style={{ minWidth: "25px" }}
                                            onClick={() => setPage(i + 1)}
                                        >
                                            {i + 1}
                                        </button>
                                    </li>
                                ))}

                                <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                                    <button
                                        className="page-link py-0 px-1"
                                        style={{ minWidth: "25px" }}
                                        onClick={() => setPage(page + 1)}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>

                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default MaterialKitchenModal;
